// export default {
//     bind(){
//         console.log("页面加载时执行")
//     }
// }

import store from "@/store";

export default {
  bind(el, bindings) {
    // // console.log("页面加载时执行")
    // if (localStorage.getItem('permissions') == null) {
    //     localStorage.setItem('permissions', '["add","edit"]')
    // }
    // 所有权限
    // const permissions = JSON.parse(localStorage.getItem('permissions'))
    const permissions = store.state.user.permission
    // console.log("permissions:", permissions);
    // console.log("el:", el);
    // console.log("bindings:", bindings);
    // 需要的权限
    const needPermission = bindings.value
    const hasPermission = permissions.includes(needPermission)
    if (!hasPermission) {
        el.style.display = 'none'
        setTimeout(() => {
            el.parentNode.removeChild(el)
        }, 0)
    }
  }
};



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermi.js